export const LANGUAGES=[
 {code:'vi',native:'Tiếng Việt',name:'Tiếng Việt',market:'VN'},
 {code:'en',native:'English',name:'Tiếng Anh',market:'GLOBAL'},
 {code:'es',native:'Español',name:'Tiếng Tây Ban Nha',market:'GLOBAL'},
 {code:'pt',native:'Português',name:'Tiếng Bồ Đào Nha',market:'GLOBAL'},
 {code:'de',native:'Deutsch',name:'Tiếng Đức',market:'DE'},
 {code:'el',native:'Ελληνικά',name:'Tiếng Hy Lạp',market:'GR'},
 {code:'hu',native:'Magyar',name:'Tiếng Hungary',market:'HU'},
 {code:'pl',native:'Polski',name:'Tiếng Ba Lan',market:'PL'},
 {code:'ro',native:'Română',name:'Tiếng Romania',market:'RO'},
 {code:'ja',native:'日本語',name:'Tiếng Nhật',market:'JP'},
 {code:'ko',native:'한국어',name:'Tiếng Hàn',market:'KR'},
 {code:'zh-TW',native:'繁體中文',name:'Tiếng Hoa phồn thể',market:'TW'}
] as const;
export type Locale=typeof LANGUAGES[number]['code'];
export const LANGUAGE_KEY='nibelc.language';
export function isLocale(value:unknown):value is Locale{return LANGUAGES.some(language=>language.code===value)}
export function savedLocale():Locale{try{const saved=localStorage.getItem(LANGUAGE_KEY);return isLocale(saved)?saved:'vi'}catch{return 'vi'}}
